module.exports = __webpack_public_path__ + "media/images/pages/commercial/pocstock-editorial-blacklivesmatter-3-353b6baf9fcdbb006c0a2cee401babda.png";